import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

export default function Loader() {
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Backdrop
  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={open}
>
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <CircularProgress color="inherit" />
    <span style={{ marginTop: 16 }}>Chargement en cours...</span>
  </div>
</Backdrop>

  );
}